import { Box, Button, Heading, Text } from "@chakra-ui/react";
import AuthenticatedUser from "../../Components/AuthenticatedUser/AuthenticatedUser";
import LoadingSpinner from "../../LoadingSpinner";

const STRIPED_BAR =
  "https://www.greatplainstribalhealth.org/wp-content/themes/generatepress_child/images/morning-star-overlay.svg";

const HeroSection = ({
  isLoading,
  userData,
  clientPrinciple,
  handleLoginClick,
}) => {
  return (
    <Box
      as="section"
      position="relative"
      width="100%"
      minHeight="40vh"
      overflow="hidden"
    >
      {/* Background image layer */}
      <Box
        position="absolute"
        inset={0}
        backgroundImage="url('https://i.imgur.com/UEw1Xba.jpeg')"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        backgroundPosition="center 80%"
      />

      {/* Morning star pattern overlay */}
      <Box
        as="img"
        src={STRIPED_BAR}
        alt=""
        aria-hidden="true"
        position="absolute"
        left="-38%"
        top={0}
        width="95%"
        height="100%"
        objectFit="cover"
        opacity={0.9}
        pointerEvents="none"
      />

      {/* Content */}
      <Box
        position="relative"
        zIndex={1}
        px={{ base: 6, md: 16 }}
        py={16}
        maxWidth="700px"
        my="auto"
      >
        <Heading
          as="h1"
          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
          fontWeight="bold"
          color="white"
          lineHeight="1.2"
          mb={2}
          textShadow="0 2px 8px rgba(0,0,0,0.5)"
        >
          Monitor &amp; Investigate
        </Heading>

        <Text
          fontSize={{ base: "md", md: "lg" }}
          color="whiteAlpha.800"
          mb={4}
          maxWidth="550px"
          textShadow="0 1px 4px rgba(0,0,0,0.4)"
        >
          Secure access to Great Plains Area data to monitor Tribal health,
          track cases, and support Relatives.
        </Text>

        <Box>
          {isLoading ? (
            <LoadingSpinner />
          ) : userData && clientPrinciple ? (
            <AuthenticatedUser userData={userData} />
          ) : (
            <Button
              size="lg"
              fontSize={{ base: "md", md: "lg" }}
              onClick={handleLoginClick}
              isDisabled={isLoading}
              px={10}
              py={6}
              colorScheme="teal"
              boxShadow="0 4px 20px rgba(0,0,0,0.3)"
              _hover={{
                transform: "translateY(-2px)",
                boxShadow: "0 6px 24px rgba(0,0,0,0.4)",
              }}
              transition="all 0.2s ease"
            >
              Sign In
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
